<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      :id="`input-shipping_address_address_2`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "ShippingAddress2",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('shipping_address.address_2')],

  data() {
    return {
      name: 'shipping_address.address_2',
      defaultLabel: this.$t("Address 2")
    }
  }
}
</script>

<style scoped>

</style>
